import { useState } from "react";
import { faqs } from "@/mocks/guaData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="max-w-3xl mx-auto">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-primary-600 font-medium text-sm">
            <i className="ri-question-line"></i> 常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-2">
            关于吃瓜频道，你想知道的都在这里
          </h2>
        </div>

        <div className="mt-8 md:mt-10 divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-100 overflow-hidden">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div key={i} className={isOpen ? "bg-background-50" : ""}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left group"
                >
                  <span className="font-medium text-foreground-950 text-[15px] md:text-base flex items-center gap-3">
                    <span className="font-heading font-bold text-primary-500 text-lg shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-2xl shrink-0 text-foreground-400 transition-transform ${
                      isOpen ? "rotate-180 text-primary-500" : ""
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <p className="px-5 md:px-6 pb-5 pl-12 md:pl-[4.75rem] text-foreground-600 text-sm md:text-[15px] leading-relaxed">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}